import type {
  ClassificationPolicy,
  Condition,
  Configuration,
  CreateClassificationPolicyRequest,
  UpdateClassificationPolicyRequest,
} from '@repo/api-gw-sdk';
import { ClassificationPoliciesApi } from '@repo/api-gw-sdk';
import type { SWRConfiguration } from 'swr';

import { encodePageToken } from '@/utils/string';

import type { HttpClient } from './httpClient';

const baseUrl = '/classification-policies';

export const classificationPolicy = (
  httpClient: HttpClient,
  config: Configuration,
  currentProjectId: string
) => {
  const classificationPoliciesApi = new ClassificationPoliciesApi(config);

  return {
    useList: (
      pageIndex?: number,
      pageSize?: number,
      _filter?: Condition,
      options?: SWRConfiguration,
      skip?: boolean
    ) => {
      const pageToken =
        pageIndex !== undefined && pageIndex > 0
          ? encodePageToken(pageIndex)
          : undefined;

      return httpClient.executeWithConfig(
        classificationPoliciesApi.listClassificationPolicies.bind(
          classificationPoliciesApi
        ),
        skip ? null : baseUrl,
        'list',
        options,
        currentProjectId,
        pageToken,
        pageSize
      );
    },
    create: (policy: CreateClassificationPolicyRequest) =>
      classificationPoliciesApi.createClassificationPolicy(
        currentProjectId,
        policy
      ),
    update: (policy: ClassificationPolicy) => {
      const input: UpdateClassificationPolicyRequest = {
        name: policy.name,
        enabled: policy.enabled,
        resourceSelector: policy.resourceSelector,
        schedule: policy.schedule,
        scheduleMode: policy.scheduleMode,
      };

      return classificationPoliciesApi.updateClassificationPolicy(
        currentProjectId,
        policy.id,
        input
      );
    },
    delete: (policyId: string) =>
      classificationPoliciesApi.deleteClassificationPolicy(
        currentProjectId,
        policyId
      ),
  };
};
